<template>
    <div>
        <div class="flex flex-between flex-v-center">
            <el-page-header @back="goBack" title="">
                <div slot="content" class="flex flex-v-center" v-if="source">
                    <h2><span class="color-primary">{{ source_index + (filterData.page - 1) * filterData.pageSize + 1
                            }}</span> / {{ total }}
                    </h2>
                </div>
            </el-page-header>


            <!-- <div class="margin-x" style="flex:1">
                <el-progress :show-text="false" :percentage="50"></el-progress>
            </div> -->

            <div class="flex flex-v-center">


                <el-tooltip placement="top" :content="$t('音频重复') + '：' + setting.times + '次'" class="margin-r">
                    <el-dropdown trigger="click" placement="bottom" @command="set_times">
                        <i style="font-size: 30px;" class="el-icon-headset pointer"></i>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="times" v-for="times in [1, 2, 3, 4, 5, 6, 7]" :key="times">
                                <h3>{{ times }}次</h3>
                            </el-dropdown-item>

                        </el-dropdown-menu>
                    </el-dropdown>

                </el-tooltip>

                <el-tooltip placement="top" :content="$t('音频倍速') + '：' + setting.speed + 'x'" class="margin-r">
                    <el-dropdown trigger="click" placement="bottom" @command="set_speed">
                        <i style="font-size: 30px;" class="el-icon-stopwatch  pointer"></i>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="speed" v-for="(speed, i) in [0.5, 0.75, 1.0, 1.25, 1.5, 2.0]"
                                :key="i">
                                <h3>{{ speed }}x</h3>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                </el-tooltip>

                <el-tooltip placement="top" :content="$t('练习列表')">
                    <i style="font-size: 30px;" @click="dialogVisible1 = true"
                        class="el-icon-document margin-r pointer"></i>
                </el-tooltip>


                <el-tooltip placement="top" :content="$t('题目设置')">
                    <i style="font-size: 30px;" @click="dialogVisible2 = true"
                        class="el-icon-notebook-2 margin-r pointer"></i>
                </el-tooltip>

                <el-tooltip placement="top" :content="$t('练习模式')">
                    <i style="font-size: 30px;" @click="get_setting()" class="el-icon-setting margin-r pointer"></i>
                </el-tooltip>







                <i style="font-size: 30px;" class="el-icon-timer"></i>
                <h3 style="letter-spacing: 2px;margin-left: 10px;"> <span>{{ timeText }}</span></h3>
            </div>
        </div>

        <div v-loading="loading" class="game flex flex-column flex-v-center flex-h-center" style="height: 80vh;">
            <div v-if="source">
                <h3 class="center">{{ source.title }} #{{ source.no }}</h3>
            </div>


            <div :style="{ opacity: answerFlag ? 1 : 0 }" class="margin-lt flex margin-b padding"
                style="gap: 15px; flex-wrap: wrap;border-radius: 10px;background-color: #e6a13c;color:#fff;">
                <div v-for="(word, i) in words" :key="i" style="text-align: center;">
                    <h4>{{ word.phonetic }}</h4>
                    <h2>{{ word.word }}</h2>
                    <el-tag class="margin-ts" size="mini">{{ word.pos }}</el-tag>
                    <h4 class="margin-ts">{{ word.meaning }}</h4>
                </div>
            </div>

            <div v-if="detail && setting.mode == '中译英模式'" class="margin-t">
                <h2 class="center">{{ meaning }}</h2>
            </div>
            <div class="flex flex-v-center flex-h-center" style="gap: 20px; flex-wrap: wrap; height: 200px;">
                <div :class="{ 'shake': shakeFlag && word.input != word.word }" class="pointer"
                    v-for="(word, i) in words" :key="i" @click="index = i">
                    <div class="center margin-b" v-if="doneFlag">
                        <el-tag type="info">
                            <h2>{{ word.phonetic }}</h2>
                        </el-tag>
                    </div>
                    <h1 class="center" style="color:transparent;">{{ word.word }}</h1>
                    <h1 :style="{ color: word.color }"
                        style="height: 60px; line-height: 60px;position: relative;z-index: 2;margin-top: -60px;"
                        class="center">{{ word.input }}
                    </h1>
                    <div
                        :style="{ backgroundColor: index == i ? '#e6a13c' : (word.color || ($store.state.theme == 'dark' ? '#fff' : '#999')), height: index == i ? '4px' : '2px' }">
                    </div>
                    <div class="center margin-ts" v-if="doneFlag">
                        <el-tag size="small">{{ word.pos }}</el-tag>
                    </div>

                    <h4 class="center margin-t" v-if="doneFlag">{{ word.meaning }}</h4>
                </div>
            </div>

            <div class="flex flex-v-center" style="gap: 40px;margin-top: 80px;">
                <el-tooltip placement="top">
                    <div slot="content"><el-tag size="small">Ctrl</el-tag> + <el-tag size="small">p</el-tag> 上一题</div>
                    <i @click="prev()" class="el-icon-arrow-left color-primary pointer"
                        style="font-size: 40px;font-weight: bold;"></i>
                </el-tooltip>

                <div class="flex flex-between flex-v-center" style="gap: 40px;">
                    <el-button :disabled="index == -1" class="flex flex-v-center pointer" @click="playType(2)"
                        type="primary" round style="gap: 5px;">
                        <el-tag size="mini">Ctrl</el-tag> + <el-tag size="mini">w</el-tag> {{ $t('播放单词') }}
                    </el-button>

                    <el-button v-if="words.length > 1" :disabled="!source || doneFlag"
                        class="flex flex-v-center pointer" @click="playWords()" type="primary" round style="gap: 5px;">
                        <el-tag size="mini">Ctrl</el-tag> + <el-tag size="mini">s</el-tag> {{ $t('播放句子') }}
                    </el-button>

                    <div @click="answerFlag = !answerFlag">
                        <el-button :disabled="!source || doneFlag" class="flex flex-v-center pointer" type="primary"
                            round style="gap: 5px;">
                            <el-tag size="mini">Ctrl</el-tag> + <el-tag size="mini">a</el-tag> {{ $t('查看答案') }}
                        </el-button>
                    </div>

                    <el-button :disabled="!source" @click="submit()" class="flex flex-v-center" type="primary" round
                        style="gap: 5px;">
                        <el-tag size="mini">Enter</el-tag> {{ doneFlag ? $t('下一题') : $t('提交') }}
                    </el-button>

                </div>

                <el-tooltip placement="top">
                    <div slot="content"><el-tag size="small">Ctrl</el-tag> + <el-tag size="small">n</el-tag>
                        {{ $t('下一题') }}</div>
                    <i @click="next()" class="el-icon-arrow-right color-primary pointer"
                        style="font-size: 40px;font-weight: bold;"></i>
                </el-tooltip>
            </div>

            <audio ref="audio" preload="metadata" @ended="playEnded()" style="display:none">
                浏览器太老咯，请升级浏览器吧~
            </audio>

            <audio v-for="i in audioCount" :key="i" :ref="'audio' + i" preload="metadata" style="display:none">
                浏览器太老咯，请升级浏览器吧~
            </audio>


        </div>

        <el-dialog v-if="dialogVisible" width="60%" top="5%" center :title="$t('练习结算')" :visible.sync="dialogVisible">
            <el-descriptions :colon="false" label-class-name="center" content-class-name="center" direction="vertical"
                class="margin-top" :column="3">
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-timer" style="font-size: 20px;"></i>
                        <h4>{{ $t('用时时长') }}</h4>
                    </template>
                    <h2> {{ time }}s</h2>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-reading" style="font-size: 20px;"></i>
                        <h4>{{ $t('单词数量') }}</h4>
                    </template>
                    <h2>{{ words.length }}</h2>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-magic-stick" style="font-size: 20px;"></i>
                        <h4>{{ $t('练习得分') }}</h4>
                    </template>
                    <h2>{{ score }}</h2>

                </el-descriptions-item>
            </el-descriptions>


            <el-descriptions :title="$t('数据分析')" :colon="false" label-class-name="center" content-class-name="center"
                direction="vertical" class="margin-top" :column="4">
                <el-descriptions-item :span="4">
                    <el-table style="width:100%" border
                        :data="[{ tag: $t('提交次数'), key: 'submitCount' }, { tag: $t('重听次数'), key: 'playCount' }, { tag: $t('答案次数'), key: 'answerCount' }]">
                        <el-table-column align="center" label="" prop="tag">

                        </el-table-column>
                        <el-table-column align="center" v-for="(word, i) in words" :key="i" :label="word.word"
                            :width="word.width">
                            <template slot-scope="scope">
                                <span size="small">{{ word[scope.row.key] }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-descriptions-item>


                <el-descriptions-item>
                    <template slot="label">
                        <el-progress :width="100" type="circle"
                            :color="score == words.length ? 'green' : (score / words.length) > 0.5 ? '#e6a23c' : 'red'"
                            :percentage="parseInt(score / words.length * 100)"></el-progress>
                    </template>
                    {{ $t('正确率') }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <el-progress :width="100" type="circle"
                            :color="submitCount == 1 ? 'green' : (submitCount == 2 ? '#e6a23c' : 'red')"
                            :percentage="parseInt(1 / submitCount * 100)"></el-progress>
                    </template>
                    {{ $t('成功率') }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <el-progress :width="100" type="circle" :color="answerCount == 1 ? '#e6a23c' : 'red'"
                            :define-back-color="answerCount == 0 ? 'green' : '#f0f0f0'"
                            :percentage="parseInt((1 - 1 / (answerCount + 1)) * 100)"></el-progress>
                    </template>
                    {{ $t('查看率') }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <el-progress :width="100" type="circle" :color="playCount == 1 ? '#e6a23c' : 'red'"
                            :define-back-color="playCount == 0 ? 'green' : '#f0f0f0'"
                            :percentage="parseInt((1 - 1 / (playCount + 1)) * 100)"></el-progress>
                    </template>
                    {{ $t('重听率') }}

                </el-descriptions-item>

            </el-descriptions>

            <div slot="footer">
                <el-button type="primary" class="margin-x" @click="prev()" round><i class="el-icon-back"></i>{{
                    $t('上一题') }}</el-button>
                <el-button class="margin-x" type="primary" @click="reDo()" round>{{ $t('再来一次') }}<i
                        class="el-icon-refresh-right"></i></el-button>
                <el-button class="margin-x" type="primary" @click="next()" round>{{ $t('下一题') }}<i
                        class="el-icon-right"></i></el-button>
            </div>
        </el-dialog>


        <el-dialog width="65%" center :title="$t('练习列表') + '(' + total + ')'" @close="close()"
            :visible.sync="dialogVisible1">
            <div style="max-height: 50vh;min-height: 20vh; overflow-y: scroll;" v-loading="loading">
                <el-table :show-header="last_source_index != -1" :data="list">
                    <el-table-column>
                        <div slot="header" class="flex flex-between flex-v-center"
                            v-if="list.length > 1 && last_source_index != -1">
                            <div>{{ $t('上次练习到') }} #{{ list[last_source_index].no }} {{ list[last_source_index].words_en
                                }}
                            </div>
                            <el-button @click="go()" size="small" type="primary">{{ $t('继续练习') }}<i
                                    class="el-icon-right"></i></el-button>
                        </div>
                        <div @click="set_source_index(scope.$index)" slot-scope="scope"
                            class="flex flex-between flex-v-center">
                            <h2 class="flex flex-v-center pointer" style="word-break: keep-all;"
                                :class="{ 'color-primary': source && source.id == scope.row.id }">
                                <el-tag size="small" type="primary">#{{
                                    scope.row.no }}</el-tag> <span class="margin-l">{{ scope.row.words_en }}</span>
                            </h2>
                            <i v-if="source && source.id == scope.row.id" style="font-size: 20px;"
                                class="el-icon-timer color-primary"></i>
                            <i v-else class="el-icon-right"></i>
                        </div>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="center">
                <el-pagination background :current-page="filterData.page" @current-change="pageChange"
                    layout="prev, pager, next, jumper" :pageSize="filterData.pageSize" :total="total">
                </el-pagination>
            </div>
        </el-dialog>



        <el-dialog width="65%" top="5%" center :title="$t('题目设置')" :visible.sync="dialogVisible2">

            <el-card class="box-card">
                <div slot="header" class="clearfix flex flex-between flex-v-center">
                    <h3>{{ $t('题型库') }}：<span class="color-primary">{{ filterData1.tag }}</span></h3>

                    <el-radio-group v-model="filterData1.type">
                        <el-radio-button :label="item" v-for="(item, i) in ['全部', '预测']" :key="i">
                            {{ $t(item) }}
                        </el-radio-button>
                    </el-radio-group>
                </div>

                <div class="flex flex-v-center" style="gap: 40px; flex-wrap: wrap;">
                    <div v-for="(type, i) in types" :key="i" class="pointer" @click="filterData1.tag = type.tag"
                        :style="{ border: filterData1.tag == type.tag ? '2px solid #e6a13c' : '2px solid transparent', padding: '10px', borderRadius: '10px' }">
                        <img :src="$host + type.logo" style="width: 80px;height: 80px;">
                    </div>
                </div>
            </el-card>

            <el-card class="margin-t">
                <div slot="header" class="clearfix">
                    <h3>{{ $t('选择难度') }}：<span class="color-primary">{{ levels[filterData1.level] }}</span></h3>
                </div>
                <el-radio-group v-model="filterData1.level">
                    <el-radio-button :label="i" v-for="(item, i) in levels" :key="i">
                        {{ $t(item) }}
                    </el-radio-button>
                </el-radio-group>
            </el-card>

            <el-card class="box-card margin-t">
                <div slot="header" class="clearfix">
                    <h3>{{ $t('每组练习数量') }}：<span class="color-primary">{{ filterData1.pageSize }}</span></h3>
                </div>


                <el-radio-group v-model="filterData1.pageSize">
                    <el-radio-button v-for="(num, i) in pageSizes" :key="i" :label="num">
                        {{ $t(num) }}
                    </el-radio-button>
                </el-radio-group>

            </el-card>

            <div slot="footer" class="center">
                <el-button class="margin-r" round type="primary" @click="get_data()" plain icon="el-icon-close">{{
                    $t('取消')
                    }}</el-button>
                <el-button class="margin-l" round type="primary" @click="set_data()" icon="el-icon-finished">{{ $t('确定')
                    }}</el-button>
            </div>
        </el-dialog>


        <el-dialog width="65%" top="5%" center :title="$t('练习模式')" :visible.sync="dialogVisible3">


            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <h3>{{ $t('选择练习模式') }}：<span class="color-primary">{{ setting1.mode }}</span></h3>
                </div>
                <el-radio-group v-model="setting1.mode">
                    <el-radio-button label="中译英模式">{{ $t('中译英模式') }}</el-radio-button>
                    <el-radio-button label="听写模式">{{ $t('听写模式') }}</el-radio-button>
                    <el-radio-button label="听力模式">{{ $t('听力模式') }}</el-radio-button>
                </el-radio-group>


                <div class="margin-t">
                    <template v-if="setting1.mode == '中译英模式'">
                        {{ $t('看到中文提示，尝试用英文表达。练习运用所学词汇和语法。') }}
                    </template>
                    <template v-if="setting1.mode == '听写模式'">
                        {{ $t('听音频，写出你听到的英文单词，训练听力，掌握单词拼写。') }}
                    </template>
                    <template v-if="setting1.mode == '听力模式'">
                        {{ $t('每句经历盲听、慢听、字幕三个阶段，逐步揭示内容，深度训练听力理解。播放次数、音频倍速与各阶段流程可在练习中按需调整。') }}
                    </template>
                </div>
            </el-card>



            <el-card class="margin-t">
                <div slot="header" class="clearfix">
                    <h3>{{ $t('选择难度') }}：<span class="color-primary">{{ setting1.level }}</span></h3>
                </div>
                <el-radio-group v-model="setting1.level">
                    <el-radio-button label="初级">{{ $t('初级') }}</el-radio-button>
                    <el-radio-button label="中级">{{ $t('中级') }}</el-radio-button>
                    <el-radio-button label="高级">{{ $t('高级') }}</el-radio-button>
                </el-radio-group>
            </el-card>

            <div slot="footer" class="center">
                <el-button class="margin-r" round type="primary" @click="set_setting(1)" plain icon="el-icon-refresh">{{
                    $t('重新开始')
                    }}</el-button>
                <el-button class="margin-l" round type="primary" @click="set_setting()" icon="el-icon-video-play">{{
                    $t('继续练习')
                    }}</el-button>
            </div>
        </el-dialog>
    </div>

</template>
<script>
import Crunker from 'crunker';
export default {
    name: 'Game',
    data() {
        return {
            dialogVisible: false,
            dialogVisible1: false,
            dialogVisible2: false,
            dialogVisible3: false,
            words: [],
            list: [],
            total: 9999,
            source_index: -1,
            chunk_index: -1,
            word_index: -1,
            meaning: null,
            last_source_index: -1,
            index: -1,
            source: null,
            detail: null,
            answerFlag: false,
            time: 0,
            score: 0,
            timer: null,
            timeText: "00:00:00",
            submitFlag: false,
            shakeFlag: false,
            checkFlag: false,
            doneFlag: false,
            loading: true,
            submitCount: 0,
            answerCount: 0,
            playCount: 0,
            pageSizes: [5, 10, 15, 20],
            levels: ['简单', '中等', '困难'],
            filterData: {
                page: 1,
                tag: 'WFD',
                level: 0,
                type: '全部',
                pageSize: 20
            },
            filterData1: {
                tag: 'WFD',
                level: 0,
                type: '全部',
                pageSize: 20
            },
            setting: {
                mode: '中译英模式',
                level: '初级',
                speed: 1.0,
                times: 1
            },
            setting1: {
                mode: '中译英模式',
                level: '初级',
            },
            times: 0,
            audioCount: 3,
            audioIndex: 0, // 轮流播放索引,
            crunker: null,
        }
    },

    computed: {
        types: function () {
            // const types = ['WFD', 'SST', 'SWT']
            const types = ['WFD']
            return this.$store.getters.getTypes().filter(type => types.includes(type.tag))
        }
    },

    watch: {
        shakeFlag: function (newVal) {
            if (newVal) {
                setTimeout(() => {
                    this.shakeFlag = false
                }, 150);
            }
        },

        dialogVisible1: function (newVal) {
            if (newVal) {
                this.stopTimer()
            } else {
                this.startTimer()
            }
        },

        source_index: function (newVal) {
            if (newVal >= 0 && this.list.length > 0 && newVal < this.list.length) {
                this.reDo()
            }
        },
    },

    created() {
        this.crunker = new Crunker();
    },
    mounted() {
        if (this.$store.getters.getRole() == 0) {
            this.loading = false
            this.$vip_alert("此功能", '', () => {
                this.$router.replace('/main')
            })
            return;
        }
        if (localStorage.getItem('game_filter_data') != undefined) {
            this.filterData = JSON.parse(localStorage.getItem('game_filter_data'))
        }

        if (localStorage.getItem('game_setting') != undefined) {
            this.setting = JSON.parse(localStorage.getItem('game_setting'))
        }

        if (localStorage.getItem('game_source_index') != undefined) {
            this.last_source_index = Number(localStorage.getItem('game_source_index'))
        }

        document.addEventListener('keydown', this.handleKeyDown)


        this.get_list(1);
    },
    beforeDestroy() {
        this.stopTimer();
        document.removeEventListener('keydown', this.handleKeyDown)

    },
    methods: {

        playEnded() {
            this.times--
            if (this.times > 0) {
                this.playWords()
            }
        },

        set_times(times) {
            this.setting.times = times
            this.cache_setting()
        },
        set_speed(speed) {
            this.setting.speed = speed
            this.cache_setting()
        },

        get_setting() {
            this.setting1 = { ...this.setting }
            this.dialogVisible3 = true
        },

        cache_setting() {
            localStorage.setItem('game_setting', JSON.stringify(this.setting))
        },

        set_setting(flag) {
            this.dialogVisible3 = false
            this.setting = { ...this.setting, ...this.setting1 }
            this.cache_setting()
            if (flag) {
                this.source_index = 0
            } else {
                this.reDo()
            }
        },


        get_data() {
            this.filterData1 = { ...this.filterData }
            this.dialogVisible2 = false
        },

        set_data() {
            this.filterData = { ...this.filterData1 }
            this.dialogVisible2 = false
            this.get_list(1)
        },

        goBack() {
            this.$router.back()
        },

        go() {
            this.set_source_index(this.last_source_index)
            this.last_source_index = -1
        },

        close() {

            if (this.source_index == -1) {
                if (this.last_source_index != -1) {
                    this.source_index = this.last_source_index
                } else {
                    this.source_index = 0
                }
            }
            this.last_source_index = -1
        },

        set_source_index(index) {
            this.source_index = index
            this.dialogVisible1 = false
        },

        pageChange(page) {
            this.filterData.page = page
            this.get_list()
        },

        reDo() {
            this.dialogVisible = false
            this.index = 0
            this.time = 0
            this.score = 0
            this.submitFlag = false
            this.answerFlag = false
            this.doneFlag = false
            this.checkFlag = false
            this.submitCount = 0
            this.playCount = 0
            this.answerCount = 0
            this.$refs.audio.pause()
            this.get_words();
        },

        getWidth(word) {
            const measureDom = document.createElement('span');
            measureDom.style.cssText = `
                font-weight:700;
                font-size:14px;
                visibility:hidden;
                position:absolute;
                white-space:nowrap;
                `;
            document.body.appendChild(measureDom);
            // 获取单词真实宽度
            measureDom.innerText = word;
            const width = measureDom.offsetWidth
            return width + 30
        },

        submit() {
            if (this.doneFlag) {
                this.next()
                return
            }
            if (this.checkFlag) return
            this.submitCount++
            this.checkFlag = true
            this.shakeFlag = true
            this.index = -1
            let flag = false
            this.words.forEach(word => {
                if (word.color != 'green') word.submitCount++
                if (word.input == word.word.toLowerCase()) {
                    word.color = "green"
                    if (!this.submitFlag) {
                        this.score++
                    }
                } else {
                    word.color = "red"
                    flag = true
                }
            })
            this.submitFlag = true
            if (flag) {
                this.playType(0)
            } else {
                this.stopTimer()
                this.doneFlag = true
                this.answerFlag = false
                this.playType(1)
                this.playWords()

                if (this.chunk_index == -1) {
                    this.detail.done = true
                } else {
                    if (this.word_index == -1) {
                        this.detail.chunks[this.chunk_index].done = true
                    } else {
                        this.detail.chunks[this.chunk_index].words[this.word_index].done = true
                    }
                }
            }
        },



        prev() {
            if (this.source_index > 0) {
                this.source_index--
            } else if (this.filterData.page > 1) {
                this.filterData.page--
                this.source_index = 19
                this.get_list()
            }
        },

        next() {
            this.doneFlag = false
            this.answerFlag = false
            if (this.detail.done) {
                this.source_index++
                return
            }
            const words = []
            this.chunk_index = this.detail.chunks.findIndex(v => !v.done)
            if (this.setting.level == '初级') {
                if (this.chunk_index == -1) {
                    this.detail.chunks.forEach(chunk => {
                        chunk.words.forEach(v => {
                            words.push({ ...v, input: '', color: '' })
                        })
                    })
                    this.meaning = this.detail.meaning
                } else {
                    this.word_index = this.detail.chunks[this.chunk_index].words.findIndex(v => !v.done)
                    if (this.word_index == -1) {
                        const chunk = this.detail.chunks[this.chunk_index]
                        chunk.words.forEach(v => {
                            words.push({ ...v, input: '', color: '' })
                        })
                        this.meaning = chunk.meaning
                    } else {
                        const word = this.detail.chunks[this.chunk_index].words[this.word_index]
                        words.push({ ...word, input: '', color: '' })
                        this.meaning = word.meaning
                    }
                }
            } else if (this.setting.level == '中级') {
                this.word_index = -1
                this.chunk_index = this.detail.chunks.findIndex(v => !v.done)
                if (this.chunk_index == -1) {
                    this.detail.chunks.forEach(chunk => {
                        chunk.words.forEach(v => {
                            words.push({ ...v, input: '', color: '' })
                        })
                    })
                    this.meaning = this.detail.meaning
                } else {
                    const chunk = this.detail.chunks[this.chunk_index]
                    chunk.words.forEach(v => {
                        words.push({ ...v, input: '', color: '' })
                    })
                    this.meaning = chunk.meaning
                }
            } else if (this.setting.level == '高级') {
                this.chunk_index = -1
                this.word_index = -1
                this.detail.chunks.forEach(chunk => {
                    chunk.words.forEach(v => {
                        words.push({ ...v, input: '', color: '' })
                    })
                })
                this.meaning = this.detail.meaning
            }
            this.words = words

            if (this.setting.mode == '听写模式') {
                this.times = this.setting.times
                this.playWords();
            }
        },

        startTimer() {
            this.stopTimer()
            this.timer = setInterval(() => {
                this.time++;
                // 格式化时间 00:00:00
                let h = parseInt(this.time / 3600)
                    .toString()
                    .padStart(2, "0");
                let m = parseInt((this.time % 3600) / 60)
                    .toString()
                    .padStart(2, "0");
                let s = parseInt(this.time % 60)
                    .toString()
                    .padStart(2, "0");
                this.timeText = `${h}:${m}:${s}`;
            }, 1000);
        },

        stopTimer() {
            if (this.timer) clearInterval(this.timer);
            this.timer = null
        },

        copyChannels(buffers) {
            buffers.forEach((buffer, index) => {
                if (buffer.numberOfChannels == 1) {
                    let audioBuffer = new AudioBuffer({ length: buffers[index].length, numberOfChannels: 2, sampleRate: buffers[index].sampleRate });
                    const anotherArray = new Float32Array(buffers[index].length)
                    buffers[index].copyFromChannel(anotherArray, 0, 0)
                    audioBuffer.copyToChannel(anotherArray, 0, 0)
                    audioBuffer.copyToChannel(anotherArray, 1, 0)
                    buffers[index] = audioBuffer;
                }
            });
            return buffers;
        },

        playWords() {
            if (this.chunk_index == -1) {
                this.$refs.audio.src = this.$host + "/api/audio/" + this.source.no + "/Andy";
            } else {
                if (this.words.length == 1) {
                    this.$refs.audio.src = this.$host + "/api/word/audio/" + this.words[0].word + '/1';
                } else {
                    this.$refs.audio.src = this.$host + "/api/word/audio/" + this.words.map(v => v.word).join(' ') + '/0';
                }
            }

            this.$refs.audio.currentTime = 0
            this.$nextTick(() => {
                this.$refs.audio.playbackRate = this.setting.speed
                this.$refs.audio.play();
            })

        },

        setPrevIndex() {
            for (let i = this.index - 1; i >= 0; i--) {
                if (this.words[i].color != 'green') {
                    this.index = i;
                    break;
                }
            }
        },

        setNextIndex() {
            if (this.index == this.words.length - 1) {
                this.submit()
                return
            }

            for (let i = this.index + 1; i < this.words.length; i++) {
                if (this.words[i].color != 'green') {
                    this.index = i;
                    if (this.submitFlag) {
                        this.words[this.index].input = ''
                    }
                    break;
                }
            }
        },
        playType(flag) {
            let src = '/web/audio/type.mp3'
            if (flag === 2) {
                this.words[this.index].playCount++
                src = this.$host + "/api/word/audio/" + this.words[this.index].word + '/1';
            } else if (flag === 1) {
                src = '/web/audio/success.mp3'
            } else if (flag === 0) {
                src = '/web/audio/fail.mp3'
            }

            this.audioIndex = (this.audioIndex + 1) % this.audioCount
            const audio = this.$refs[`audio${this.audioIndex + 1}`][0]
            audio.src = src
            audio.currentTime = 0
            audio.play().catch(err => { console.log(err) }) // 防报错
        },

        handleKeyDown(e) {
            if (this.doneFlag) {
                if (e.code == 'Enter' || e.code == 'Space') {
                    this.next()
                }
                return
            }
            if (e.code != 'Enter') {
                this.checkFlag = false
            }
            if (e.code == 'Space') {
                this.setNextIndex()
            } else if (e.code == 'Backspace') {
                if (this.words[this.index].input) {
                    this.words[this.index].input = this.words[this.index].input.slice(0, -1);
                } else {
                    this.setPrevIndex()
                }
                this.playType()
            } else if (e.code == 'Enter') {
                this.submit()
            } else if (e.ctrlKey) {
                if (e.key == "w") {
                    this.playType(2);
                } else if (e.key == "s") {
                    this.playWords();
                } else if (e.key == "a") {
                    this.show_answer()
                } else if (e.key == "n") {
                    this.next()
                } else if (e.key == "p") {
                    this.prev()
                }
            } else if (/^[A-Za-z']$/.test(e.key)) {
                if (this.index == -1) {
                    this.index = this.words.findIndex(v => v.input != v.word)
                    if (this.index == -1) return
                    this.words[this.index].input = ''
                }
                this.words[this.index].input += e.key;
                this.words[this.index].color = ""
                this.playType()
            }
            e.preventDefault()
        },

        show_answer() {
            if (this.answerFlag) return
            this.answerCount++
            this.words.forEach(item => {
                if (item.word != item.input) {
                    item.answerCount++
                }
            })
            this.answerFlag = true
        },

        get_list(flag) {
            this.loading = true
            this.$http.post('/api/game/list', this.filterData).then(res => {
                this.list = res.data;
                this.total = res.total
                if (flag) this.dialogVisible1 = true
                this.loading = false
            });
        },
        get_words() {
            this.loading = true
            this.source = this.list[this.source_index];
            this.$http.post('/api/game/detail', { id: this.source.id }).then(data => {
                this.detail = data
                this.next()


                this.startTimer()
                this.loading = false
                localStorage.setItem('game_filter_data', JSON.stringify(this.filterData))
                localStorage.setItem('game_source_index', this.source_index)
            });
        },
        step() {
            const words = []
            if (this.setting.level == '初级') {
                let word = this.detail.chunks[this.chunk_index].words.find(v => !v.done)
                if (word) {
                    word.input = ''
                    word.color = ''
                    words.push(word)
                    this.meaning = word.meaning
                } else {
                    if (this.detail.chunks[this.chunk_index].done) {
                        this.chunk_index++
                        if (this.chunk_index < this.detail.chunks.length) {
                            this.step()
                        } else {
                            this.stopTimer()
                            this.doneFlag = true
                            this.dialogVisible = true
                            this.playType(1)
                        }
                    } else {
                        this.detail.chunks[this.chunk_index].words.forEach(v => {
                            v.input = ''
                            v.color = ''
                            words.push(v)
                        })
                        this.meaning = this.detail.chunks[this.chunk_index].meaning
                    }
                }
            }
            this.words = words
        }
    },
};
</script>

<style scoped>
/* 拼写错误：波浪下划线 + 抖动动画 */
.shake {
    animation: shake 0.1s ease-in-out;
}

/* 左右轻微抖动 */
@keyframes shake {
    0% {
        transform: translateX(0px);
    }

    25% {
        transform: translateX(-6px);
    }

    75% {
        transform: translateX(6px);
    }

    100% {
        transform: translateX(0px);
    }
}
</style>